type AchievementProps = {
  rating: number
  ratingsCount: number
  wonShipments: number
}
const DriverAchievements: React.FC<AchievementProps> = ({
  rating,
  ratingsCount,
  wonShipments,
}) => {
  return (
    <section className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">Achievements</h2>
      <div className="space-y-4">
        <div className="bg-gray-50 rounded-lg p-4 flex items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z"
              fill="url(#paint0_linear_4012_5085)"
            />
            <path
              d="M19 24.27L25.18 28L23.54 20.97L29 16.24L21.81 15.63L19 9L16.19 15.63L9 16.24L14.46 20.97L12.82 28L19 24.27Z"
              fill="#7B6215"
            />
            <mask
              id="mask0_4012_5085"
              maskUnits="userSpaceOnUse"
              x="9"
              y="9"
              width="20"
              height="19"
            >
              <path
                d="M19 24.27L25.18 28L23.54 20.97L29 16.24L21.81 15.63L19 9L16.19 15.63L9 16.24L14.46 20.97L12.82 28L19 24.27Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_4012_5085)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 7H31V31H7V7Z"
                fill="url(#paint1_linear_4012_5085)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_4012_5085"
                x1="0"
                y1="0"
                x2="36.0697"
                y2="39.7515"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFF5DA" />
                <stop offset="0.5057" stopColor="#FFF5DA" />
                <stop offset="0.8559" stopColor="#F9E6B6" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_4012_5085"
                x1="19"
                y1="7"
                x2="19"
                y2="31"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#E9B601" />
                <stop offset="1" stopColor="#E97205" />
              </linearGradient>
            </defs>
          </svg>

          <div className="pl-4">
            <span className="flex items-center justify-center">
              Rating:
              <span className="font-semibold pl-1"> {rating.toFixed(1)}</span>
              <span className="text-gray-700 pl-1">
                Based on {ratingsCount} ratings
              </span>
            </span>
          </div>
        </div>
        <div className="bg-gray-50 rounded-lg p-4 flex items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z"
              fill="url(#paint0_linear_4012_5100)"
            />
            <g clipPath="url(#clip0_4012_5100)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26 11H25V9H23V11H15V9H13V11H12C10.89 11 10.01 11.9 10.01 13L10 27C10 28.1 10.89 29 12 29H26C27.1 29 28 28.1 28 27V13C28 11.9 27.1 11 26 11ZM22.47 18L17.59 22.88L15.47 20.76L14.41 21.82L17.59 25L23.53 19.06L22.47 18ZM12 27H26V16H12V27Z"
                fill="#4A4A4A"
              />
              <mask
                id="mask0_4012_5100"
                maskUnits="userSpaceOnUse"
                x="10"
                y="9"
                width="18"
                height="20"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M26 11H25V9H23V11H15V9H13V11H12C10.89 11 10.01 11.9 10.01 13L10 27C10 28.1 10.89 29 12 29H26C27.1 29 28 28.1 28 27V13C28 11.9 27.1 11 26 11ZM22.47 18L17.59 22.88L15.47 20.76L14.41 21.82L17.59 25L23.53 19.06L22.47 18ZM12 27H26V16H12V27Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_4012_5100)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7 8H31V32H7V8Z"
                  fill="url(#paint1_linear_4012_5100)"
                />
              </g>
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_4012_5100"
                x1="0"
                y1="0"
                x2="37.625"
                y2="38.3678"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.484375" stopColor="#FFF5DA"></stop>
                <stop offset="1" stopColor="#FFF4D7"></stop>
              </linearGradient>
              <linearGradient
                id="paint1_linear_4012_5100"
                x1="9"
                y1="10"
                x2="27.5"
                y2="28"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#29A8EF" />
                <stop offset="1" stopColor="#127DB9" />
              </linearGradient>
              <clipPath id="clip0_4012_5100">
                <rect width="38" height="38" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>

          <span className="pl-4">Booked {wonShipments} times</span>
        </div>
        <div className="bg-gray-50 rounded-lg p-4 flex items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_4012_5118)">
              <path
                d="M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z"
                fill="url(#paint0_linear_4012_5118)"
              ></path>
              <path
                d="M29.177 27.4611L27.6244 30.3408L24.3712 30.7727L21.7095 32.7165L18.6042 31.6366L15.351 32.2845L12.9111 30.0528L9.7319 29.2609L8.54892 26.2373L6.0351 24.1496L6.40478 20.91L5 17.9583L6.70053 15.2227L6.8484 11.9831L9.58403 10.2553L11.1367 7.3757L14.3899 6.94375L17.0516 5L20.2308 6.00787L23.484 5.35995L25.8499 7.66366L29.0292 8.45556L30.2121 11.4792L32.726 13.5669L32.4302 16.7345L33.7611 19.6861L32.0605 22.4938L31.9866 25.7334L29.177 27.4611Z"
                fill="url(#paint1_linear_4012_5118)"
              ></path>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.7537 15.5541C17.6244 15.5541 18.3303 14.8482 18.3303 13.9775C18.3303 13.1067 17.6244 12.4009 16.7537 12.4009C15.883 12.4009 15.1771 13.1067 15.1771 13.9775C15.1771 14.8482 15.883 15.5541 16.7537 15.5541ZM12.5493 19.7585C13.42 19.7585 14.1259 19.0526 14.1259 18.1819C14.1259 17.3111 13.42 16.6053 12.5493 16.6053C11.6786 16.6053 10.9727 17.3111 10.9727 18.1819C10.9727 19.0526 11.6786 19.7585 12.5493 19.7585ZM23.9354 13.9775C23.9354 14.8482 23.2295 15.5541 22.3588 15.5541C21.488 15.5541 20.7822 14.8482 20.7822 13.9775C20.7822 13.1067 21.488 12.4009 22.3588 12.4009C23.2295 12.4009 23.9354 13.1067 23.9354 13.9775ZM26.5632 19.7585C27.4339 19.7585 28.1398 19.0526 28.1398 18.1819C28.1398 17.3111 27.4339 16.6053 26.5632 16.6053C25.6924 16.6053 24.9866 17.3111 24.9866 18.1819C24.9866 19.0526 25.6924 19.7585 26.5632 19.7585ZM22.1847 19.9155C22.3674 20.1308 22.553 20.3495 22.7499 20.5804C22.799 20.6296 22.8488 20.679 22.899 20.7288C23.6925 21.5166 24.5797 22.3975 24.3959 23.6075C24.213 24.2444 23.7526 24.8877 22.9265 25.0706C22.7146 25.1112 22.289 25.0557 21.7389 24.9839C21.0936 24.8997 20.2769 24.7931 19.4327 24.7931H19.3192C18.4821 24.7931 17.6721 24.8997 17.0294 24.9843C16.4713 25.0577 16.0394 25.1145 15.8255 25.0706C14.9993 24.8877 14.539 24.2507 14.3561 23.6075C14.1782 22.404 15.0649 21.5238 15.8581 20.7362C15.9087 20.6861 15.9589 20.6362 16.0084 20.5867C16.3641 20.1744 16.6809 19.801 17.0071 19.4166C17.1898 19.2012 17.3754 18.9825 17.5724 18.7516C17.8688 18.411 18.2345 18.0705 18.676 17.9191C18.7453 17.8939 18.8147 17.875 18.8841 17.8624C19.048 17.8308 19.2183 17.8308 19.3823 17.8308C19.5463 17.8308 19.7165 17.8308 19.8742 17.8561C19.9436 17.8687 20.0129 17.8876 20.0823 17.9128C20.5237 18.0642 20.8958 18.4047 21.1859 18.7453C21.5417 19.1576 21.8585 19.5311 22.1847 19.9155Z"
                fill="#1A1A1A"
              ></path>
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_4012_5118"
                x1="7.5"
                y1="6"
                x2="32"
                y2="33"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.484375" stopColor="#FFF5DA"></stop>
                <stop offset="1" stopColor="#FFF4D7"></stop>
              </linearGradient>
              <linearGradient
                id="paint1_linear_4012_5118"
                x1="5.36678"
                y1="8.89719"
                x2="29.1909"
                y2="32.0206"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FCCF51"></stop>
                <stop offset="0.859645" stopColor="#FFBE6C"></stop>
              </linearGradient>
              <clipPath id="clip0_4012_5118">
                <rect width="38" height="38" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>

          <span className="pl-4">Pet Transport Expert</span>
        </div>
      </div>
    </section>
  )
}
export default DriverAchievements
